
import { Component, Vue, Provide, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { recruition_form_list } from './lib/form_struct';
import moment from 'moment';
import UploadFile from './component/upload-file.vue';
import UserDefined from './component/user-defined.vue';
import BatchModifying from './component/batch-modifying.vue';
import Table from './component/recruition-table.vue';
import { recruition_modifying_list } from './lib/modifying';
import { recruitingUpload } from './lib/upload-file';
import { static_options } from './lib/options';

const getUrl = require('baimahu/url-with-param');
const { VUE_APP_FCAPI: FCAPI } = process.env;
const Hundun = namespace('Hundun');
const API = {
  get_recruiting_list: `${FCAPI}/boss/hundun/chuang/recruiting`,
  edit_recruiting_batch: `${FCAPI}/boss/hundun/chuang/recruiting/batch/0`,
  creat_recruiting_upload: `${FCAPI}/boss/hundun/chuang/recruiting/batch`,
  edit_custom_config: `${FCAPI}/boss/hundun/chuang/customconfig/0`,
  get_custom_config: `${FCAPI}/boss/hundun/chuang/customconfig`
};
@Component({
  components: { UploadFile, UserDefined, BatchModifying, Table }
})
export default class MissionDetail extends Vue {
  /* eslint-disable */
  @Hundun.State('teacher_list') teacher_list!: any; //负责班主任
  @Hundun.State('branch_office') branch_office!: any; //分社选项
  @Hundun.State('tag_list') tag_list: any; //标签
  @Watch('teacher_list')
  valueChange(newValue: any) {
    this.search_info_list.charger_id.options = newValue;
    this.dialog_form_list.charger_id.options = newValue.slice(1, newValue.length - 1);
  }
  @Watch('tag_list')
  tagListChange(newValue: any) {
    this.search_info_list.tag_id.bind.options = newValue.filter((item: any) => item.type == 1);
    this.search_info_list.tag_id_chuang.bind.options = newValue.filter((item: any) => item.type == 2);
  }
  search_info_list: any = recruition_form_list;
  btn_list: Array<any> = [
    { id: 1, label: '批量修改', type: 'primary' },
    { id: 2, label: '自定义表头', type: 'primary' },
    { id: 3, label: '导入', type: 'primary' },
    { id: 4, label: '导出', type: 'primary' },
    { id: 5, label: '搜索', type: 'primary' },
    { id: 6, label: '清空搜索条件', type: 'link' }
  ];
  is_loading = false;
  data_list = [];
  upload_visible = false;
  modifying_dialog_visible = false;
  user_define_dialog_visible = false;
  pagenation_info = { current: 0, limit: 0, total: 0 };
  user_define_form_list: any = [];
  dialog_form_list = JSON.parse(JSON.stringify(recruition_modifying_list));
  select_row_key = [];
  download_sign = 0; // 0否，1导出，
  user_define_list: any = [];

  @Provide('getTableList')
  async getList(page = 1) {
    this.is_loading = true;

    const custom_list = this.user_define_list
      .filter((item: any) => item.value)
      .map((item: any) => ({
        id: item.id,
        type: item.type == 1 ? 'text' : 'select',
        value: item.value || ''
      }));
    const tag_id = (): any[] => {
      const tag_arr: any[] = [];
      if (this.search_info_list.tag_id.value) {
        this.search_info_list.tag_id.value.forEach((element: any) => {
          tag_arr.push(element[element.length - 1]);
        });
      }
      if (this.search_info_list.tag_id_chuang.value) {
        this.search_info_list.tag_id_chuang.value.forEach((element: any) => {
          tag_arr.push(element[element.length - 1]);
        });
      }
      return tag_arr.filter((item: any) => item != undefined);
    };

    const send_data = {
      name: this.search_info_list.name.value,
      mobile: this.search_info_list.mobile.value,
      corp_name: this.search_info_list.corp_name.value,
      corp_position: this.search_info_list.corp_position.value,
      income_min: this.search_info_list.income.value.first,
      income_max: this.search_info_list.income.value.second,
      charger_id: this.search_info_list.charger_id.value.join(',') || undefined,
      status: this.search_info_list.status.value,
      followup: this.search_info_list.followup.value,
      target_periods: this.search_info_list.target_periods.value,
      interviewer: this.search_info_list.interviewer.value,
      fee_channel: this.search_info_list.fee_channel.value,
      interview_time_start: this.search_info_list.interview_time.value[0] ? moment(this.search_info_list.interview_time.value[0]).startOf('days').unix() : undefined,
      interview_time_end: this.search_info_list.interview_time.value[1] ? moment(this.search_info_list.interview_time.value[1]).endOf('day').unix() : undefined,
      time_start: this.search_info_list.time.value[0] ? moment(this.search_info_list.time.value[0]).startOf('days').unix() : undefined,
      time_end: this.search_info_list.time.value[1] ? moment(this.search_info_list.time.value[1]).endOf('day').unix() : undefined,
      source: this.search_info_list.source.value.join(',') || undefined,
      source_desc: this.search_info_list.source_desc.value,
      tag_id: tag_id().join(','),
      custom_list: encodeURIComponent(JSON.stringify(custom_list)),
      current: page,
      limit: 20,
      is_export: this.download_sign
    };
    console.log(this.search_info_list.source);

    if (this.download_sign) {
      const url = getUrl(API.get_recruiting_list, send_data);
      this.$axios.get(url).then((res) => {
        if (res.data.status === 200) {
          this.$message.info(res.data.data);
        } else {
          window.location.href = url;
        }
      });
    } else {
      const res = await this.$axios.get(API.get_recruiting_list, { params: send_data });
      console.log(res);

      if (res.data.status != 200) return this.$message.error('搜索失败！');
      this.pagenation_info = { current: res.data.data.current, limit: res.data.data.limit, total: res.data.data.total };
      this.data_list = res.data.data.detail;
      this.data_list.forEach((item: any) => {
        item.time = item.time ? moment(item.time * 1000) : null;
        item.fee_time = item.fee_time ? moment(item.fee_time * 1000) : null;
        item.interview_time = item.interview_time ? moment(item.interview_time * 1000) : null;
        item.status = item.status == 0 ? null : item.status;
        item.chuang_user.source = item.chuang_user.source
          .split(',')
          .map(Number)
          .filter((item: any) => item != 0);
        item.charger_id = item.charger_id
          .split(',')
          .map(Number)
          .filter((item: any) => item != 0);
        item.fee_channel = item.fee_channel == 0 ? null : item.fee_channel;

        const custom_list = this.user_define_list.map((element: any) => ({ channel: 2, customconfig_id: element.id, custom_value: undefined }));
        item.custom.forEach((element: any) => {
          custom_list.forEach((val: any) => {
            if (element.customconfig_id == val.customconfig_id) val.custom_value = element.custom_value;
          });
        });
        item.custom_list = custom_list;
      });
    }
    console.log(this.data_list);

    this.is_loading = false;
    this.download_sign = 0;
  }
  // 翻页

  // 确认导入
  async uploadOk(file_list: any) {
    const send_data = recruitingUpload(file_list, { teacher_list: this.teacher_list, ...static_options });
    const res = await this.$axios.post(API.creat_recruiting_upload, { data: send_data.res });
    if (res.data.status != 200) return this.$message.error('导入失败！');
    this.$message.success('导入成功！');
    this.upload_visible = false;
  }
  // 取消导入
  uploadCancel() {
    this.upload_visible = false;
    //
  }
  // 自定义表头确认
  async UserDefinedOk(list: any, type: number) {
    this.user_define_dialog_visible = false;
    const send_data: any = { channel: 2, add: [], edit: [] };
    list.forEach((element: any) => {
      if (element.type == 1) element.options = '';
      if (element.id) {
        send_data.edit.push(element);
      } else {
        send_data.add.push(element);
      }
    });
    console.log(send_data);

    const res = await this.$axios.put(API.edit_custom_config, send_data);
    if (res.status != 200 && res.data.status != 200) return this.$message.error('编辑失败！');
    this.$message.success('编辑成功！');
    this.getCustomConfig();

    //
  }
  // 获取自定义表头
  async getCustomConfig() {
    const res = await this.$axios.get(API.get_custom_config, { params: { channel: 2 } });
    if (res.data.status !== 200) return this.$message.error('自定义表头获取失败！');
    this.user_define_form_list = res.data.data;
    this.user_define_form_list.forEach((element: any) => {
      element.options = [...element.options.split(',').map((item: any) => ({ value: item }))];
    });
    this.user_define_list = JSON.parse(JSON.stringify(this.user_define_form_list));
    this.user_define_list.forEach((item: any) => {
      item['value'] = undefined;
    });
    console.log(this.user_define_list);
  }
  // 取消自定义表头弹窗
  UserDefinedCancel(list: any, type: number) {
    this.user_define_dialog_visible = false;
  }
  // 确认批量修改
  async handleOk(list: any) {
    const charger_name = [] as any[];
    console.log(list);

    list.charger_id?.value?.forEach((element: any) => {
      this.teacher_list.forEach((item: any) => {
        if (item.id == element) charger_name.push(item.weixin_nickname);
      });
    });
    const send_data = {
      id: this.select_row_key,
      charger_id: (list.charger_id.value && list.charger_id.value.join(',')) || undefined,
      charger_name: charger_name.join(',') || undefined,
      status: list.status.value && list.status.value.join(','),
      source: list.source.value && list.source.value.join(','),
      source_desc: list.source_desc.value,
      target_periods: list.target_periods.value,
      interviewer: list.interviewer.value,
      fee_channel: list.fee_channel.value,
      followup: list.followup.value,
      cover_level: 0
    };
    const res: any = await this.$axios.put(`${API.edit_recruiting_batch}`, send_data);
    if (res.status == 200) {
      this.$message.success('批量修改成功！');
      this.getList(this.pagenation_info.current);
      this.select_row_key = [];
      Object.values(this.dialog_form_list).forEach((element: any) => (element.value = undefined));
    }
    this.modifying_dialog_visible = false;
    (this.$refs.table as any).select_row_key = this.select_row_key = [];
    Object.values(this.dialog_form_list).forEach((element: any) => (element.value = undefined));
  }
  // 取消批量修改
  handleCancel() {
    this.modifying_dialog_visible = false;
    Object.values(this.dialog_form_list).forEach((element: any) => (element.value = undefined));
  }
  // 表格select选择
  onSelectChange(select_row_key: any) {
    this.select_row_key = select_row_key;
  }
  btnClick(val: number) {
    switch (val) {
      case 1:
        if (this.select_row_key.length <= 0) return this.$message.error('请先勾选要批量修改的用户！');
        this.dialog_form_list.charger_id.options = this.teacher_list.slice(1, this.teacher_list.length - 1);
        this.modifying_dialog_visible = true;
        break;
      case 2:
        this.user_define_dialog_visible = true;
        console.log(val);
        break;
      case 3:
        this.upload_visible = true;
        break;
      case 4:
        this.download_sign = 1;
        this.getList();
        break;
      case 5:
        this.download_sign = 0;
        this.getList();
        break;
      case 6:
        Object.keys(this.search_info_list).forEach((key: any) => {
          if (this.search_info_list[key].key == 'income') {
            this.search_info_list[key].value.first = undefined;
            this.search_info_list[key].value.second = undefined;
          } else if (
            this.search_info_list[key].key == 'interview_time' ||
            this.search_info_list[key].key == 'time' ||
            this.search_info_list[key].key == 'charger_id' ||
            this.search_info_list[key].key == 'source' ||
            this.search_info_list[key].key == 'tag_id' ||
            this.search_info_list[key].key == 'tag_id_chaung' ||
            this.search_info_list[key].key == 'undelivered_module'
          ) {
            this.search_info_list[key].value = [];
          } else this.search_info_list[key].value = undefined;
        });
        this.user_define_list.forEach((element: any) => {
          element.value = undefined;
        });
        this.$forceUpdate();
        (this.$refs.table as any).select_row_key = this.select_row_key = [];
        break;
      default:
        break;
    }
  }
  async created() {
    if (this.$route.query?.time) {
      this.search_info_list.time.value = [moment(1451577600000), moment(Number(this.$route.query?.time) * 1000)];
      this.search_info_list.charger_id.value = this.teacher_list.filter((item: any) => this.$route.query?.name == item.charge)?.map((item: any) => item.id) || [];
    }

    await this.getCustomConfig();
    await this.getList();
    this.search_info_list.charger_id.options = this.teacher_list;

    const arr = ['黄茜', '雷媛媛'];
    if (localStorage['master:profile']) {
      if (!arr.includes(JSON.parse(localStorage['master:profile']).data.name)) {
        this.btn_list = this.btn_list.filter((item: any) => item.id != 2);
      }
    }
    if (localStorage['beta:profile']) {
      if (!arr.includes(JSON.parse(localStorage['beta:profile']).data.name)) {
        this.btn_list = this.btn_list.filter((item: any) => item.id != 2);
      }
    }
  }
}
